import type { ButtonProps } from "@mui/material";
import classNames from "classnames";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../shared/components/AppButton";
import { SoundTextIcon } from "../../../../../shared/icons/SoundTextIcon";
import type { SidebarModalsType } from "../../../types";
import styles from "../styles.module.css";
import type { SidebarButtonSize } from "../types";

interface Props extends ButtonProps {
  buttonSize?: SidebarButtonSize;
  openSoundToText: (type: SidebarModalsType) => void;
}

export const SoundToTextButton: FC<Props> = ({
  openSoundToText,
  buttonSize,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"text"}
      onClick={() => openSoundToText("soundToText")}
      icon={<SoundTextIcon />}
      className={classNames(styles.button, {
        [styles["pd.block-16"]]: buttonSize === "middle",
        [styles["pd.block-10"]]: buttonSize === "small",
      })}
      {...props}
    >
      {t("sidebar.recognize_audio_button")}
    </AppButton>
  );
};
